// defaultData.js - 默认数据结构，仅作为备用
// 这个文件取代了原来的 data.js，提供了空的数据结构，实际数据将从 Markdown 文件加载

// 默认简历数据
export const resumeData = {
  personalInfo: {
    name: "",
    title: "",
    email: "",
    phone: "",
    location: "",
    summary: ""
  },
  
  experiences: [],
  projects: [],
  education: []
};
